<div *ngIf="((totalCount$ | async) ?? 0) > 0" class="results-text" i18n>
  Showing <span class="results-highlight">{{ showingFrom$ | async }}</span> to
  <span class="results-highlight">{{ showTo$ | async }}</span> of
  <span class="results-highlight">{{ totalCount$ | async }}</span>
  <span [ngPlural]="totalCount$ | async">
    <ng-template ngPluralCase="=1"> result</ng-template>
    <ng-template ngPluralCase="other"> results</ng-template>
  </span>
</div>
<div class="no-results-text" *ngIf="((totalCount$ | async) ?? 0) === 0" i18n>No Results</div>
